@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container total-score-container double">
    @for (group of optionGroup.options | slice: 0 : visibleOptionsLimit; track trackOption($index, group)) {
        <div class="attribute-key">{{ group.name }}</div>
        <ms-option
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [option]="group"
            [optionGroup]="optionGroup"
            [event]="event"
            [showOptionName]="false"
            [showPromoBadge]="!!crmPromoIdsMap.options[group.id]"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails" />
    }
</div>

@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }}
        <span class="right-icon"><vn-icon name="theme-right" size="12" /></span>
    </div>
}
